import type { Training } from "../../../api/training/Training.typed";

export function trainingAlertTitle(agency: string, qualification: string): string {
  return [agency, qualification].filter(Boolean).join(" ").trim() || "Formation";
}

export function trainingAlertLabels(training: Training): string[] {
  return (training.Alerts ?? []).map((alert) => alert.Label).filter((label) => label.length > 0);
}
